import React from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, ViewStyle } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { Platform, Text as RNText } from 'react-native';
import { MODULE_COLORS } from '@cubemeet/core';

export interface TravelUploadReceiptButtonProps {
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  t?: (key: string) => string;
  style?: ViewStyle;
  labelOverride?: string;
}

const defaultStrings: Record<string, string> = {
  uploadLabel: '上传收据',
  uploading: '上传中...',
};

const resolveLabel = (t: ((key: string) => string) | undefined, key: keyof typeof defaultStrings) => {
  if (!t) return defaultStrings[key];
  try {
    const value = t(`travelDetail.actions.${key}`);
    if (value && value !== `travelDetail.actions.${key}`) {
      return value;
    }
  } catch (error) {
    // fall back
  }
  try {
    const value = t(`expenseManagement.${key}`);
    if (value && value !== `expenseManagement.${key}`) {
      return value;
    }
  } catch (error) {
    // fall back
  }
  return defaultStrings[key];
};

const TravelUploadReceiptButton: React.FC<TravelUploadReceiptButtonProps> = ({
  onPress,
  disabled = false,
  loading = false,
  t,
  style,
  labelOverride,
}) => {
  const label = labelOverride ? labelOverride : resolveLabel(t, loading ? 'uploading' : 'uploadLabel');

  const RenderIcon: React.FC<{ name: string; size?: number; color?: string }> = ({ name, size = 18, color = '#fff' }) => {
    const resolvedName = name ? name.replace(/-/g, '_') : name;
    return <Icon name={resolvedName} size={size} color={color} />;
  };

  return (
    <TouchableOpacity
      style={[styles.button, disabled && styles.disabledButton, style]}
      onPress={onPress}
      disabled={disabled || loading}
      activeOpacity={0.8}
    >
      {loading ? (
        <ActivityIndicator size="small" color="#fff" />
      ) : (
        <RenderIcon name="cloud-upload" />
      )}
      <Text style={styles.label}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 18,
    paddingVertical: 10,
    borderRadius: 24,
    backgroundColor: MODULE_COLORS.travel,
    minWidth: 120,
    gap: 8,
  },
  disabledButton: {
    opacity: 0.6,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: '#fff',
  },
});

export default TravelUploadReceiptButton;
